// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__LiEkb","sendOtp":"AuthorizeToLogin_sendOtp__12R5F"};